const $window = $(window);
const $destinationLayoutLeft = $('.destination-layout__left');
const $contentSection = $('.destination-layout');

const TOP_OFFSET = 150;
const DEFAULT_TOP_OFFSET = 40;

const destinationLayout = {
  initialize() {
    if (!$destinationLayoutLeft.length) {
      return;
    }

    this.refreshData();

    this.createListeners();
  },

  /**
   * Create event listeners
   * @return {void}
   */
  createListeners() {
    $window.on('scroll:virtual', (e, scrollTop) => {
      this.checkFixed(scrollTop);
    });

    $window.on('resize load', () => {
      this.refreshData();
    });
  },

  refreshData() {
    this.enabled = this.getEnabledState();

    this.windowWidth = $window.width();
    this.defaultLeftOffset = this.windowWidth >= 1200 ? 0 : -15;

    // Return to it's original state for calculations
    this.setRelative();

    this.defaultLeftOffset = $window.width() >= 1200 ? 0 : -15;
    this.leftOffset = $destinationLayoutLeft.offset().left;

    this.fixedStart = $destinationLayoutLeft.offset().top - TOP_OFFSET;

    const contentSectionBottomOffset = $contentSection.offset().top + $contentSection.height();
    this.fixedEnd = contentSectionBottomOffset - (TOP_OFFSET + $destinationLayoutLeft.height());

    this.checkFixed($window.scrollTop());
  },

  /**
   * Check if the fixed check should be enabled
   * @return {boolean}
   */
  getEnabledState() {
    return (this.windowWidth >= 992);
  },

  /**
   * Check if the destinations should be fixed
   * @param  {int} scrollTop
   * @return {void}
   */
  checkFixed(scrollTop) {
    if (!this.enabled) {
      return;
    }

    if (scrollTop > this.fixedEnd) {
      this.setBottomFixed();
    } else if (scrollTop > this.fixedStart) {
      this.setFixed();
    } else {
      this.setRelative();
    }
  },

  /**
   * Set the destinations to fixed
   * @return {void}
   */
  setFixed() {
    $destinationLayoutLeft.css({
      position: 'fixed',
      left: this.leftOffset,
      top: TOP_OFFSET,
      bottom: 'auto',
    });
  },

  /**
   * Set the destinations to fixed
   * @return {void}
   */
  setBottomFixed() {
    $destinationLayoutLeft.css({
      position: 'absolute',
      left: this.defaultLeftOffset,
      top: 'auto',
      bottom: 0,
    });
  },

  /**
   * Set destinations to relative
   * @return {void}
   */
  setRelative() {
    $destinationLayoutLeft.css({
      position: 'absolute',
      left: this.defaultLeftOffset,
      top: DEFAULT_TOP_OFFSET,
      bottom: 'auto',
    });
  },
};

export default destinationLayout;
